module.exports = __webpack_public_path__ + "img/login.1d626caa.png";